import { http } from 'vue'
let r1 = false
export default {
  loadLoyaltyAgreement (context, params = {}) {
    return http.get('loyalty-agreements?company_id=' + params.company_id, {
      before (request) {
        if (r1) r1.abort()
        r1 = request
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/loyalty_agreements/actions.js